module.exports = __webpack_public_path__ + "static/img/user6.a61928e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/user6.jpg
// module id = 8nzD
// module chunks = 23